import React from "react";

const StatusChangeModal = ({ user, onConfirm, onClose }) => {
  if (!user) return null;

  const isActive = user.status === "A";
  const actionText = isActive ? "Inactive" : "Active";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[2000]">
      <div className="bg-white text-start rounded-xl p-6 w-full max-w-[400px] shadow-xl">

        {/* Header */}
        <h2 className="text-xl font-semibold mb-4">
          Make user {actionText}?
        </h2>

        {/* Message */}
        <p className="text-gray-600 mb-6">
          Are you sure you want to change the status of{" "}
          <span className="font-semibold">
            {user.firstname} {user.lastname}
          </span>
          ?
        </p>

        {/* Buttons */}
        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 rounded-md border border-gray-300 text-gray-700"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="px-4 py-2 rounded-md bg-[#1D2951] text-white"
            onClick={() => onConfirm(user)}
          >
            Yes, Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusChangeModal;
